let recaptchaLoadPromise = null;
function loadRecaptchaScript(siteKey) {
    if (window.grecaptcha?.enterprise)
        return Promise.resolve();
    if (recaptchaLoadPromise)
        return recaptchaLoadPromise;
    recaptchaLoadPromise = new Promise((resolve, reject) => {
        const existing = document.querySelector('script[src*="recaptcha/enterprise.js"]');
        if (existing) {
            // If a script exists, wait until grecaptcha appears and is ready
            const start = Date.now();
            const tick = () => {
                if (window.grecaptcha?.enterprise) {
                    // Call ready() to ensure reCAPTCHA is fully initialized
                    window.grecaptcha.enterprise.ready(() => {
                        recaptchaLoadPromise = null;
                        resolve();
                    });
                    return;
                }
                if (Date.now() - start > 10_000) {
                    recaptchaLoadPromise = null;
                    return reject(new Error('reCAPTCHA script failed to load'));
                }
                requestAnimationFrame(tick);
            };
            tick();
            return;
        }
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
            if (!window.grecaptcha?.enterprise) {
                recaptchaLoadPromise = null;
                reject(new Error('reCAPTCHA Enterprise API not available after script load'));
                return;
            }
            window.grecaptcha.enterprise.ready(() => {
                recaptchaLoadPromise = null;
                resolve();
            });
        };
        script.onerror = () => {
            recaptchaLoadPromise = null;
            reject(new Error('Failed to load reCAPTCHA Enterprise script'));
        };
        document.head.appendChild(script);
    });
    return recaptchaLoadPromise;
}
async function executeRecaptcha(siteKey, action) {
    if (!siteKey)
        throw new Error('reCAPTCHA site key is required');
    if (!action)
        throw new Error('reCAPTCHA action is required');
    await loadRecaptchaScript(siteKey);
    const enterprise = window.grecaptcha?.enterprise;
    if (!enterprise)
        throw new Error('reCAPTCHA Enterprise API is not available');
    const token = await enterprise.execute(siteKey, { action });
    if (!token)
        throw new Error('reCAPTCHA execution returned an empty token');
    return token;
}

export { executeRecaptcha };
//# sourceMappingURL=recaptcha.js.map
